import { defineMessages } from 'react-intl';

const messages = defineMessages({
  message: {
    id: 'NoResults.Message',
    defaultMessage: 'No Results Found',
  },
});

export default messages;
